import { formatAmount } from "@/helpers/decimal_helper";

export const AmountColumn = ({ amount, onClick }) => {

    return (
        <div className="d-flex align-items-end justify-content-end" onClick={onClick} style={{ cursor: "pointer" }}>
            <span>{formatAmount(amount)}</span>
        </div>
    )
}
